import React from 'react';
import PropTypes from 'prop-types';

import { IMG_ERROR, IMG_EMPTY } from '../../../../data/assets/img';

import CustomHeader from '../../../../components/customheader';
import SpinnerLoader from '../../../../components/spinnerloader';
import ShowMessage from '../../../../components/showmessage';

class CardContainer extends React.PureComponent {
    renderCardLoader = () => {
        if (this.props.loading) {
            return (
                <div className={`ori-absolute ori-align-full ori-zindex-100 ori-flex-row ori-flex-jc ori-flex-ac ${this.props.loader_container_class}`}>
                    <SpinnerLoader size="large" text="loading" />
                </div>
            );
        }
    };

    renderCustomHeader = () => {
        if (this.props.show_custom_header) {
            return (
                <CustomHeader {...this.props.custom_header_props} />
            );
        }
    };

    renderChildren = () => {
        const { load_error, emtpy_condition, container_height, err_title, err_msg, show_err_btn, err_btn_text, empty_title, empty_msg, show_empty_btn, empty_btn_text, err_btn_click, children } = this.props;
        if (!load_error) {
            if (emtpy_condition) { //TODO: spelling mistake : empty_condition
                return (
                    <div style={{ height: `${container_height}px` }}>
                        <ShowMessage img_src={IMG_EMPTY} height={140} width={160} title={empty_title} message={empty_msg} button_text={empty_btn_text} show_button={show_empty_btn} />
                    </div>
                );
            }
            return (children);
        }
        return (
            <div style={{ height: `${container_height}px` }}>
                <ShowMessage img_src={IMG_ERROR} height={100} width={100} title={err_title} message={err_msg} button_text={err_btn_text} show_button={show_err_btn} handleButtonClick={err_btn_click} />
            </div>
        );
    };

    render() {
        const { card_container_class } = this.props;
        return (
            <div className={`ori-relative ori-border-radius-4 ${card_container_class}`}>
                {this.renderCardLoader()}
                {this.renderCustomHeader()}
                {this.renderChildren()}
            </div>
        );
    }
}

CardContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    card_container_class: PropTypes.string,
    loader_container_class: PropTypes.string,
    custom_header_props: PropTypes.object,
    loading: PropTypes.bool,
    show_custom_header: PropTypes.bool,
    load_error: PropTypes.bool,
    container_height: PropTypes.number,
    err_title: PropTypes.string,
    err_msg: PropTypes.string,
    show_err_btn: PropTypes.bool,
    err_btn_text: PropTypes.string,
    emtpy_condition: PropTypes.bool,
    empty_title: PropTypes.string,
    empty_msg: PropTypes.string,
    show_empty_btn: PropTypes.bool,
    empty_btn_text: PropTypes.string,
    err_btn_click: PropTypes.func,
};

CardContainer.defaultProps = {
    card_container_class: "ori-animated ori-fade-in ori-box-shadow-light ori-tb-mrgn-10 ori-bg-white ori-lr-pad-15 ori-b-pad-10",
    loading: false,
    show_custom_header: false,
    load_error: false,
    container_height: 350,
    err_title: 'Error',
    err_msg: 'Unable to fetch data',
    show_err_btn: false,
    err_btn_text: 'Reload',
    emtpy_condition: false,
    empty_title: 'Record not found',
    empty_msg: 'No record avaliable for this filters',
    show_empty_btn: false,
    empty_btn_text: 'Reload',
    loader_container_class: 'ori-bg-white ori-opacity-medium'
};

export default CardContainer;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/cardcontainer/index.js